import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { CategoryIdEnum, CategoryNamesEnum, CategorySlugEnum } from "../types";

export const useGetCategoryName = () => {
  const [searchParams] = useSearchParams();
  const categoryParam = searchParams.get("category");

  const category = useMemo(() => {
    let slug: string = undefined;

    // Normalize to title-case so "junk" → "Junk", "moving" → "Moving", etc.
    const multiple = categoryParam
      ?.split(",")
      .map((s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase());

    if (multiple?.includes(CategorySlugEnum.Moving)) {
      slug = CategorySlugEnum.Moving;
    } else if (multiple?.includes(CategorySlugEnum.Labor)) {
      slug = CategorySlugEnum.Labor;
    } else {
      slug = multiple?.[0] ?? CategorySlugEnum.Junk;
    }

    return {
      id: CategoryIdEnum[slug],
      name: CategoryNamesEnum[slug],
      slug: CategorySlugEnum[slug],
      isMultiple: multiple?.length > 1,
      multiple,
      plainText: categoryParam,
    };
  }, [categoryParam]);

  return category;
};
